import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

export function PaymentCancel() {
  const navigate = useNavigate();

  const handleRetryPayment = () => {
    navigate('/billing');
  };

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Payment Cancelled</h2>
        <p className="text-gray-600 mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        
        <div className="bg-orange-50 p-4 rounded-lg mb-6 text-left">
          <h3 className="font-semibold text-orange-900 mb-2">What happened?</h3>
          <p className="text-sm text-orange-800">
            You cancelled the payment process or closed the checkout window. Your subscription remains unchanged.
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleRetryPayment}
            className="w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium flex items-center justify-center"
          >
            <CreditCard className="w-4 h-4 mr-2" />
            Try Payment Again
          </button>
          <button
            onClick={handleBackToDashboard}
            className="w-full px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </button>
        </div>

        <p className="text-xs text-gray-500 mt-6">
          If you encountered any issues during checkout, please contact our support team for assistance.
        </p>
      </div>
    </div>
  );
}

export default PaymentCancel;